import { types } from '../constants/types';

export const authReducer = (state = {}, action) => {
  switch (action.type) {
    case types.login:
      return {
        ...state,
        logged: true,
        auth: action.payload
      }

    case types.logout:
      return {
        logged: false
      }

    default:
      return state;
  }
};
